export * from './table-master-detail';
